import React, {useState} from 'react';
import SummaryLoader from '../loaders/SummaryLoader';
import {
    convertNumber,
    numWithComma,
    getTitleFaIranFinancialMarkets,
    getBahabinText,
    getTodayString, getSignWithPercent, getSymbolFromFullSymbol
} from "../../util/DominantUtil";
import SummaryStyle from "./SummaryStyle";
import {Helmet} from 'react-helmet'
import starkString from "starkstring";
import KeyValueList from "../KeyValue/KeyValueList";

export default function StockSummary({data}) {

    function getColor() {
        const summaryCP = data.changePercent;
        const predicate = summaryCP ? summaryCP : data.p
        return predicate > 0 ? '#00873c' : '#eb0f29'
    }

    const symbol = getSymbolFromFullSymbol(data.s);
    const faN = data.faN ? `(${data.faN})` : '';
    const company = data.cn ? `(${data.cn})` : '';
    const formattedName = `${faN || company || ''}${symbol}`;

    // console.log(data)

    return (
        <div className="stock-summary">
            <div className="row">
                <div className="faa-parent animated-hover" style={{margin: '0 15px 0 5px'}}>
                </div>
                <h1 className="text-right persian-font">
                    {formattedName}
                </h1>
            </div>
            <div className="row no-gutters last-title text-left items-baseline">
                        <span style={{
                            fontSize: '36px',
                            fontWeight: '700'
                        }}>{data.o ? data.c : convertNumber(data.c)}</span>
                <span style={{
                    paddingLeft: '10px',
                    color: getColor()
                }}>
                      {typeof data.p === 'number' ? (data.o ? data.p.toFixed(2) : convertNumber(data.p.toFixed(2))) : null}
                </span>
                {data.P &&
                    <span style={{
                        paddingLeft: '10px',
                        color: getColor()
                    }}>{`(${getSignWithPercent(data.P.toFixed(2))}%)`}</span>
                }
            </div>
            <KeyValueList data={data}/>
            <SummaryStyle/>
        </div>
    )
}